const OptionsUtils = {
    kinship: [
        {value: "pai", label: "Pai"},
        {value: "mae", label: "Mãe"},
        {value: "filho", label: "Filho"},
        {value: "filha", label: "Filha"},
        {value: "enteado", label: "Enteado"},
        {value: "enteada", label: "Enteada"},
        {value: "irmao", label: "Irmão"},
        {value: "irma", label: "Irmã"},
        {value: "neto", label: "Neto"},
        {value: "neta", label: "Neta"},
        {value: "conjuge", label: "Cônjuge"},
    ],

    actions: [
        {value: "Comportamento - Excelente", label: "Comportamento - Excelente"},
        {value: "Comportamento - Bom", label: "Comportamento - Bom"},
        {value: "Comportamento - Regular", label: "Comportamento - Regular"},
        {value: "Comportamento - Insatisfatório", label: "Comportamento - Insatisfatório"},
        {value: "Elogios", label: "Elogios"},
        {value: "Gratificações", label: "Gratificações"},
        {value: "Nomeação", label: "Nomeação"},
        {value: "Processos", label: "Processos"},
        {value: "Sanções disciplinares", label: "Sanções disciplinares"},
    ],

    dayOff: [
        {value: "MEDICAL_CERTIFICATE", label: "Atestado"},
        {value: "VACATION", label: "Férias"},
        {value: "DAY_OFF", label: "Folga"},
        {value: "PAID_DAY_OFF", label: "Folga abonada"},
        {value: "LICENSE", label: "Licença"},
        {value: "SHIFT_CHANGE", label: "Troca de plantão"},
    ],

    typePhones: [
        {value: "CELULAR", label: "CELULAR"},
        {value: "COMERCIAL", label: "COMERCIAL"},
        {value: "CONTATO", label: "CONTATO"},
        {value: "CORPORATIVO", label: "CORPORATIVO"},
        {value: "RESIDENCIAL", label: "RESIDENCIAL"},
    ],

    sex: [
        {value: "MALE", label: "Masculino"},
        {value: "FEMALE", label: "Feminino"},
    ],

    sex2: [
        {value: "MASCULINO", label: "Masculino"},
        {value: "FEMININO", label: "Feminino"},
    ],

    booleanOptions: [
        {value: "true", label: "Sim"},
        {value: "false", label: "Não"},
    ],

    educationLevel: [
        {value: "illiterate", label: "Não alfabetizado"},
        {value: "elementarySchool", label: "Fundamental"},
        {value: "highSchool", label: "Médio"},
        {value: "university", label: "Superior"},
        {value: "postGraduate", label: "Pós-graduação"},
        {value: "master", label: "Mestrado"},
        {value: "doctorate", label: "Doutorado"},
    ],

    maritalStatus: [
        {value: "CASADO(A)", label: "Casado(a)"},
        {value: "DIVORCIADO(A)", label: "Divorciado(a)"},
        {value: "SEPARADO(A)", label: "Separado(a)"},
        {value: "SOLTEIRO(A)", label: "Solteiro(a)"},
        {value: "UNIÃO ESTÁVEL", label: "União Estável"},
        {value: "VIÚVO(A)", label: "Viúvo(a)"},
    ],

    addressType: [
        {value: "COMERCIAL", label: "Comercial"},
        {value: "RESIDENCIAL", label: "Residencial"},
    ],

    categoryCnh: [
        {value: "A", label: "A"},
        {value: "B", label: "B"},
        {value: "C", label: "C"},
        {value: "D", label: "D"},
        {value: "E", label: "E"},
    ],

    skillsRestrictionType: [
        {value: "SUITABLE", label: "Aptidão"},
        {value: "RESTRICTION", label: "Restrição"}
    ],

    getValue: (value) => {
        if (value) {
            return {value: value, label: value}
        }

        return null;
    }
}

export default OptionsUtils;